import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    width: 220,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"
  },
  wrapper: {},
  scrollableContainer: {
    maxHeight: "calc(100vh - 330px)",
    overflowY: "auto",
    "&.production": {
      display: "flex",
      height: "100%",
      alignItems: "end"
    }
  },
  header: {
    position: "relative",
    paddingTop: 24,
    marginBottom: 12,

    "&:before": {
      content: '""',
      position: "absolute",
      zIndex: -1,
      left: 0,
      right: 0,
      top: 0,
      height: theme.heightDesktopHeader,
      display: "block",
      backgroundImage:
        "repeating-linear-gradient(to bottom, " +
        "#103827 0px, #103827 25%, " +
        "#2d6c51 25%, #2d6c51 50%, " +
        "#489b77 50%, #489b77 75%, " +
        "#61c69e 75%, #61c69e 100%)"
    }
  },
  avatar: {
    width: 78,
    height: 78,
    marginBottom: 14,
    background: theme.palette.secondary.main,
    margin: "0 auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  avatarIcon: {
    fontSize: 68
  },
  avatarPicture: {
    width: "100%",
    height: "100%"
  },
  name: {
    textAlign: "center",
    fontSize: 22,
    lineHeight: 1,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    color: "#1a1a1a"
  },
  status: {
    textAlign: "center",
    fontSize: 14
  },

  content: {},

  listItem: {
    height: 56,
    paddingLeft: 19,
    paddingRight: 19,
    color: theme.palette.text.secondary,
    borderBottom: "1px solid #eeeeee",
    "&:first-child": {
      borderTop: "1px solid #eeeeee"
    }
  },
  listItemSelected: {
    color: "#1a1a1a",
    borderBottom: `1px solid ${theme.palette.text.hint}`
  },
  listItemText: {
    fontSize: 16,
    lineHeight: 1
  },
  icon: {
    fontSize: 22
  },
  listItemIcon: {
    minWidth: 35,
    color: theme.palette.text.secondary
  },
  listItemIconSelected: {
    color: "#1a1a1a"
  },
  footer: {},
  listItemFooter: {
    height: 68
  },
  link: {
    textDecoration: "none"
  },
  iconButton: {
    marginLeft: 14,
    [theme.breakpoints.down("md")]: {
      marginLeft: 12
    },
    [theme.breakpoints.down("xs")]: {
      marginLeft: 4
    }
  },
  accountCircle: {
    width: 24,
    height: 24,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    fontWeight: "bold",
    fontSize: 12
  }
}));
